import { Box, styled, Typography } from '@mui/material';

export const StyledHelperTextContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const StyledHelperTextTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: 12,
  fontStyle: 'normal',
  '& a': {
    color: 'inherit',
    fontWeight: 700,
    textDecoration: 'underline',
  },
}));

export const StyledSpan = styled('span')({
  fontWeight: 700,
  textDecoration: 'underline',
});
